import React from 'react'
import FormsFilters from './FormsFilters'
import InstitutionsFilters from './InstitutionsFilters'
import ReceivedRequestsFilters from './ReceivedRequestsFilters'
import { Form } from 'react-final-form'
import AutoSave from '../../../molecules/AutoSave'
import AccordionFilter from '../../../molecules/filters/AccordionFilter'
import PropTypes from 'prop-types'
import UsersFilters from './UsersFilters'
import AnswersFilters from './AnswersFilters'
import AppliedFilters from './AppliedFilters'
import AttendedRequestsFilters from './AttendedRequestsFilters'
import AppliedAttendedRequestFilter from './applied_filter/AppliedAttendedRequestFilter'

const FilterForm = ({ selectedIndicator, fetchFilteredData, initialFilters, accessRules }) => {
  if (!accessRules.includes(selectedIndicator)) {
    return null
  }

  const formTypeIndicators = handleSubmit => ({
    forms: <FormsFilters />,
    institutions: <InstitutionsFilters />,
    users: <UsersFilters />,
    answers: <AnswersFilters />,
    receivedRequests: <ReceivedRequestsFilters onChange={handleSubmit} />,
    attendedRequests: <AttendedRequestsFilters />
  })

  return (
    <Form
      onSubmit={fetchFilteredData}
      initialValues={initialFilters}
      render={({ handleSubmit, form }) => (
        <form onSubmit={handleSubmit} className="bg-neutral-100">
          <AutoSave debounce={1000} save={fetchFilteredData} />
          <AccordionFilter hasHeader keepOnClear={['published', 'date_from', 'date_to']}>
            <div className="md:pt-6 gap-10 mt-5 md:mt-0 w-full">
              {formTypeIndicators(fetchFilteredData)[selectedIndicator]}
            </div>
          </AccordionFilter>
          <div className="p-6 pb-0">
            {selectedIndicator === 'attendedRequests' ? (
              <AppliedAttendedRequestFilter form={form} />
            ) : (
              <AppliedFilters form={form} selectedIndicator={selectedIndicator} />
            )}
          </div>
        </form>
      )}
    />
  )
}

FilterForm.propTypes = {
  selectedIndicator: PropTypes.string.isRequired,
  fetchFilteredData: PropTypes.func.isRequired,
  initialFilters: PropTypes.object.isRequired,
  accessRules: PropTypes.array.isRequired
}

export default FilterForm
